import React, { Component } from 'react';
import { Colors } from '../../utils/variables';
import './mailingListSignup.scss';

export default class MailingListSignup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      isSubmitting: false,
      isSubmitted: false,
      error: null
    };
  }

  handleEmailChange = (e) => {
    this.setState({ email: e.target.value, error: null });
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!this.state.email) {
      this.setState({ error: 'Please enter your email address' });
      return;
    }

    if (!this.validateEmail(this.state.email)) {
      this.setState({ error: 'Please enter a valid email address' });
      return;
    }

    this.setState({ isSubmitting: true, error: null });

    try {
      // Google Apps Script Web App URL
      const scriptURL = 'https://script.google.com/macros/s/AKfycbzVD69UXj-GL3Dffi6Nz8ZfcDlIaQ37bslXZ85-jdcYLNxxlDHuE9OoWM8ISVGRMYhV-g/exec';
      
      // Create a hidden iframe to submit the form
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.name = 'hidden_iframe';
      document.body.appendChild(iframe);

      // Create form
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = scriptURL;
      form.target = 'hidden_iframe';
      form.style.display = 'none';

      // Add form fields
      const emailInput = document.createElement('input');
      emailInput.name = 'email';
      emailInput.value = this.state.email;
      form.appendChild(emailInput);

      const timestampInput = document.createElement('input');
      timestampInput.name = 'timestamp';
      timestampInput.value = new Date().toISOString();
      form.appendChild(timestampInput);

      const sourceInput = document.createElement('input');
      sourceInput.name = 'source';
      sourceInput.value = 'Website Footer';
      form.appendChild(sourceInput);

      const actionInput = document.createElement('input');
      actionInput.name = 'action';
      actionInput.value = 'subscribe';
      form.appendChild(actionInput);

      document.body.appendChild(form);

      // Handle iframe load event
      iframe.onload = () => {
        // Clean up
        document.body.removeChild(form);
        document.body.removeChild(iframe);
        
        // Show success message
        this.setState({ 
          isSubmitted: true, 
          isSubmitting: false, 
          email: '' 
        });
      };

      // Submit form
      form.submit();

      // Fallback timeout in case iframe doesn't load
      setTimeout(() => {
        if (this.state.isSubmitting) {
          this.setState({ 
            isSubmitted: true, 
            isSubmitting: false, 
            email: '' 
          });
        }
      }, 3000);

    } catch (error) {
      console.error('Error:', error);
      this.setState({ 
        error: 'Something went wrong. Please try again later.',
        isSubmitting: false 
      });
    }
  }

  validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  render() {
    const { email, isSubmitting, isSubmitted, error } = this.state;

    if (isSubmitted) {
      return (
        <div className="mailing-list-signup" style={{color: Colors.white, backgroundColor: Colors.primary}}>
          <div className="signup-content" style={{backgroundImage: 'url(/images/topo-texture.png)'}}>
            <h2>Thank You!</h2>
            <p>You've been successfully added to our mailing list. We'll keep you updated on our latest adventures and initiatives.</p>
          </div>
        </div>
      );
    }

    return (
      <div className="mailing-list-signup" style={{color: Colors.white, backgroundColor: Colors.primary}}>
        <div className="signup-content" style={{backgroundImage: 'url(/images/topo-texture.png)'}}>
          <h2>Stay Connected</h2>
          <p className="subheading">Join our mailing list to stay updated on Peak Purpose initiatives, events, and mountain biking adventures.</p>
          
          <form onSubmit={this.handleSubmit} className="signup-form">
            <div className="form-group">
              <input
                type="email"
                value={email}
                onChange={this.handleEmailChange}
                placeholder="Enter your email address"
                className="email-input"
                disabled={isSubmitting}
              />
              <button 
                type="submit" 
                className="submit-button"
                disabled={isSubmitting}
                style={{backgroundColor: Colors.primaryDark}}
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </button>
            </div>
            {error && <p className="error-message">{error}</p>}
          </form>
        </div>
      </div>
    );
  }
} 